'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const OsmEmbed = dynamic(
  () => import('./OsmEmbed'),
  {
    ssr: false,
    loading: () => (
      <div className="w-full h-full flex items-center justify-center bg-pond/30">
        <span className="font-mono text-chartreuse/40 text-xs animate-pulse">Memuat peta...</span>
      </div>
    ),
  }
);

export default function MapDisplay() {
  return <OsmEmbed />;
}
